<template>
  <div id="app" class="site container hfeed content-page-wrap">
    <HeadNav selectedLanguage="en" :page="page" />

    <div class="site-content">
      <article class="content-page">
        <header v-if="showHero" class="page-hero">
          <div class="hero-badge" v-if="badge">{{ badge }}</div>
          <h1>{{ title }}</h1>
          <p v-if="subtitle" class="hero-subtitle">{{ subtitle }}</p>
          <button v-if="showDownload" class="download-btn" @click="download">
            <img src="@/assets/android.svg" alt="Android" />
            Download GB WhatsApp APK
          </button>
        </header>

        <slot />

        <div v-if="showDownload && !showHero" class="download-cta">
          <button class="download-btn" @click="download">
            <img src="@/assets/android.svg" alt="Android" />
            Download Latest GB WhatsApp
          </button>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/content-page.scss';
import HeadNav from '@/components/HeadNav.vue';
import apkMixin from '@/mixins/apkMixin';

export default {
  name: 'ContentPageLayout',
  components: { HeadNav },
  mixins: [apkMixin],
  provide() {
    return {
      apkActions: {
        downloadVersion: (item) => this.downloadVersion(item),
      },
    };
  },
  props: {
    page: { type: String, default: 'gb' },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    badge: { type: String, default: '' },
    showHero: { type: Boolean, default: true },
    showDownload: { type: Boolean, default: true },
  },
};
</script>
